export default __webpack_public_path__ + "images/AE.6579734.png";